@switch (status()) {
  @case (statuser.laster_data) {
    <button mat-stroked-button disabled="true">
      {{ 'Laster...'|translate }}
    </button>
  }
  @case (statuser.moete_ikke_publisert) {
    <button mat-stroked-button color="primary" (click)="publiserMoete()">
      {{ 'Publiser møtet'|translate }}
    </button>
  }
  @case (statuser.moete_ikke_avholdt) {
    <button mat-stroked-button disabled="true">
      {{ 'Møtet er ikke avholdt'|translate }}
    </button>
  }
  @case (statuser.protokoll_ikke_publisert) {
    <button mat-stroked-button color="primary" (click)="publiserProtokoll()">
      {{ 'Publiser protokollen'|translate }}
    </button>
  }
  @case (statuser.protokoll_kan_sendes_til_signering) {
    <button mat-stroked-button color="primary" (click)="sendProtokollTilSignering()">
      {{ 'Send protokollen til signering'|translate }}
    </button>
  }
  @case (statuser.protokoll_under_arbeid) {
    <button mat-stroked-button color="primary" disabled="true">
      {{ 'Protokollen er under arbeid'|translate }}
    </button>
  }
  @case (statuser.protokoll_skal_signeres_av_bruker) {
    <button mat-stroked-button color="primary" (click)="signerProtokoll()">
      {{ 'Signer protokollen'|translate }}
    </button>
  }
  @case (statuser.protokoll_venter_paa_signaturer) {
    <button mat-stroked-button
            [nedtrekksmenyTriggerFor]="signatarerOversikt" nedtrekksmenyBredde="500px"
            nedtrekksmenyKlasse="møteprotokoll-status-signatarer-panel"
            (nedtrekksmenyAapnet)="signatarerOversiktAapnet()"
            [matTooltip]="'{andel} av {totalt} har signert' | translate: {andel: moetestatus.aktivtSteg.progresjon.andel, totalt: moetestatus.aktivtSteg.progresjon.totalt}"
            data-testid="protokoll_venter_paa_signaturer">
      <span class="pai-og-tekst">
        <c3-todelt-pai [andel]="moetestatus.aktivtSteg.progresjon.andel"
                       [totalt]="moetestatus.aktivtSteg.progresjon.totalt"
                       [konfig]="pieKonfigBlaa"/>
        <span>{{ 'Venter på signaturer'|translate }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </span>
    </button>
  }
  @case (statuser.protokoll_signert_men_ikke_konvoluttert) {
    <button mat-stroked-button
            [nedtrekksmenyTriggerFor]="signatarerOversikt" nedtrekksmenyBredde="500px"
            nedtrekksmenyKlasse="møteprotokoll-status-signatarer-panel"
            (nedtrekksmenyAapnet)="signatarerOversiktAapnet()"
            class="ferdig">
      <span class="pai-og-tekst">
        <c3-todelt-pai [andel]="1" [totalt]="1" [konfig]="pieKonfigGroenn"/>
        <span>{{ 'Protokollen er signert, avventer teknisk fullføring'|translate }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </span>
    </button>
  }
  @case (statuser.protokoll_signert) {
    <button mat-stroked-button
            [nedtrekksmenyTriggerFor]="signatarerOversikt" nedtrekksmenyBredde="500px"
            nedtrekksmenyKlasse="møteprotokoll-status-signatarer-panel"
            (nedtrekksmenyAapnet)="signatarerOversiktAapnet()"
            class="ferdig">
      <span class="pai-og-tekst">
        <c3-todelt-pai [andel]="1" [totalt]="1" [konfig]="pieKonfigGroenn"/>
        <span>{{ 'Protokollen er ferdig signert'|translate }}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </span>
    </button>
  }
}

<nedtrekksmeny #signatarerOversikt>
  @if (laster()) {
    <mat-progress-bar mode="indeterminate"/>
  }
  <h2>{{ 'Signeringsstatus'|translate }}</h2>
  <signering-status [signatarer]="signatarer()" [status]="moete().protokollSigneringStatus"/>
</nedtrekksmeny>
